import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import withStyles from 'react-jss';
import { useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);

const { Option } = Select;

const FabricForm = props => {
  const {
    productIndex,
    styleIndex,
    classes,
    getValues,
    setValue,
    control,
    accessoryItem,
    accessoryIndex,
    accessoriesAppend,
    accessoriesRemove,
    AccessoriesForSample,
    watch,
  } = props;

  const accessoryStocks = useSelector(state => state.accessoryStocks);

  const updateRow = useCallback(
    ({ Consumption, AdditionalPercentage, Stock } = {}) => {
      const accessory =
        getValues(
          `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}]`
        ) || {};

      const styleQuantity =
        +getValues(
          `products[${productIndex}].styles[${styleIndex}].totalQuantity`
        ) || 1;

      const consumption =
        Consumption === undefined ? +accessory.consumption || 0 : +Consumption;

      const additionalPercentage =
        AdditionalPercentage === undefined
          ? +accessory.additionalPercentage || 0
          : +AdditionalPercentage;

      const stock = Stock === undefined ? +accessory.stock || 0 : +Stock;

      if (Stock !== undefined) {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].stock`,
          +stock || 0
        );
      }

      const quantity = +consumption * +styleQuantity;

      const totalQuantity = (
        (+quantity || 0) *
        (1 + (+additionalPercentage || 0) / 100)
      ).toFixed(2);

      setValue(
        `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].quantity`,
        quantity
      );
      setValue(
        `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].totalQuantity`,
        totalQuantity
      );

      if (+stock >= +totalQuantity) {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].toOrder`,
          0
        );
      } else {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].toOrder`,
          +(+totalQuantity - +stock).toFixed(2)
        );
      }
    }
  );

  useEffect(() => {
    const productId = getValues(`products[${productIndex}].productId`);

    const accessoryId = getValues(
      `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].accessoryId`
    );

    const stockObject = accessoryStocks[`P${productId}A${accessoryId}`];

    updateRow({ Stock: stockObject ? stockObject.stock : 0 });
  }, [
    accessoryStocks,
    watch(
      `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].accessoryId`
    ),
    watch(
      `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].colorId`
    ),
  ]);

  useEffect(() => {
    updateRow();
  }, [
    watch(
      `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].consumption`
    ),
    watch(
      `products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].additionalPercentage`
    ),
  ]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].accessoryId`}
          control={control}
          defaultValue={accessoryItem.accessoryId}
          render={({ field }) => (
            <AntSelect allowClear placeholder="Select Accessory" {...field}>
              {AccessoriesForSample.map((accessory, index) => (
                <Option key={index} value={accessory.id}>
                  {accessory.accessory}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].consumption`}
          control={control}
          defaultValue={accessoryItem.consumption}
          render={({ field }) => (
            <AntInput
              placeholder="Consumption"
              {...field}
              type="number"
              size="small"
              allowClear={false}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].quantity`}
          control={control}
          defaultValue={accessoryItem.quantity}
          render={({ field }) => (
            <AntInput
              placeholder="Quantity"
              {...field}
              type="number"
              size="small"
              disabled
              allowClear={false}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].additionalPercentage`}
          control={control}
          defaultValue={accessoryItem.additionalPercentage}
          render={({ field }) => (
            <AntInput
              allowClear={false}
              size="small"
              placeholder="Shrinkage %"
              type="number"
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].totalQuantity`}
          control={control}
          defaultValue={accessoryItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="Total Quantity"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].stock`}
          control={control}
          defaultValue={accessoryItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="Stock"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].accessories[${accessoryIndex}].toOrder`}
          control={control}
          defaultValue={accessoryItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="To Order"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            const accessories = getValues(
              `products[${productIndex}].styles[${styleIndex}].accessories`
            );
            if (accessories && accessories.length > 1) {
              accessoriesRemove(accessoryIndex);
            }
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined onClick={() => accessoriesAppend({})} />
      </td>
    </tr>
  );
};

FabricForm.propTypes = {
  classes: PropTypes.object.isRequired,
  styleIndex: PropTypes.number.isRequired,
  productIndex: PropTypes.number.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  accessoryItem: PropTypes.object.isRequired,
  accessoryIndex: PropTypes.number.isRequired,
  accessoriesAppend: PropTypes.func.isRequired,
  accessoriesRemove: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  AccessoriesForSample: PropTypes.array,
};

export default withStyles(styles)(FabricForm);
